import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const currencyApi = createApi({
    reducerPath: 'currencyApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/common/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    tagTypes: ["Currency"],
    endpoints: (builder) => ({
        getCurrency: builder.query({
            query: () => `currencyList`,
            providesTags: ["Currency"],
        }),
        addCurrency: builder.mutation({
            query: (newCurrency) => ({
                url: 'currency',
                method: 'POST',
                body: newCurrency,
            }),
            invalidatesTags: ['Currency'],
        }),
        deleteCurrency: builder.mutation({
            query: ({ id }) => ({
                url: `currency/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Currency'],
        }),
    }),
})

export const { useGetCurrencyQuery, useAddCurrencyMutation, useDeleteCurrencyMutation } = currencyApi